// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__sMsXw","loadingText":"styles_loadingText__1Pfzi"};